<template>
	<div class="animated fadeIn">
	  <b-row>
		<b-col md="12">
		   <b-card>
				<div slot="header">
					<strong>OFD Report</strong> 
				</div>
				<b-row>
					<b-col md="4">
						<b-form-group label="Select Date"  :label-cols="4" >
							<v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null,  end: null}' v-model='selectedDate'></v-date-picker>
						</b-form-group>
					</b-col>  
					<b-col md="4" v-if="is_superadmin==1" style="display: block;">
						<b-form-group label="Hub Id"
						  :label-cols="2" >
						  <b-form-select  v-model="selected_serviceid" @input="checkHub" >
							<option value="">--Please Select Hub--</option>
							<option v-for="hub in hublistData"  v-bind:value="hub.pickuplocationmasterid" >{{hub.pickuplocationname}}</option>
						</b-form-select> 
						</b-form-group>
					</b-col>
					<b-col md="4">
						<b-form-group label="Delivery Agent"  :label-cols="4" >
							<v-select  v-model="selected_deliverydata" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(selected_deliverydata)"  name="deliveryagentid">
							</v-select>

							<!-- <b-form-select  v-model="selected_deliverydata" @input="checkdata" >
								<option value="">--Please Select Delivery Agent--</option>
								<option v-for="deliverydata in data1"  v-bind:value="deliverydata.deliveryagentmasterid" >
									{{ deliverydata.deliveryagentfirstname | capitalize }} {{ deliverydata.deliveryagentlastname | capitalize }} - {{ deliverydata.deliveryagentmobilenumber}}
								</option>
							</b-form-select>  -->
						</b-form-group>
					  </b-col>
				</b-row>
				<b-row style="float: right;">
					<b-col md="3">
						<b-button variant="primary" @click="StatusOfdInKSA(1)">Search</b-button>
					</b-col>
					<b-col md="3">
						<b-button variant="danger" @click="clear()">Clear</b-button>
					</b-col>
					<b-col md="3">
						<b-button variant="primary" @click="Downloadofd()" :disabled="totalcount==0">Download</b-button>
					</b-col>
				</b-row>
				<br><br>
		        <b-col sm="12" class="text-right">
				   <p > <b>Total Records :
					<span style="color:red;margin-right: 10px;">{{totalcount}}</span></b> </p>
			   </b-col> 
			   <b-col sm="12">
					<b-table responsive  show-empty :busy="isBusy"   :items="ofdstatus" :fields="fields"  :current-page="currentPage"  :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc" :sort-direction="sortDirection"  @filtered="onFiltered" :bordered="bordered"  >
						<div slot="table-busy" class="text-center text-danger my-2">
							<b-spinner class="align-middle"></b-spinner>
							<strong>Loading...</strong>
						  </div>
				</b-table>
			   </b-col>

			   <b-col sm="12" class="my-1" v-if="this.totalcount>15">
					<paginate 
						:page-count="noofpages"
						:page-range="10"
						:margin-pages="2"
						:click-handler="StatusOfdInKSA"
						:prev-text="'Prev'"
						:next-text="'Next'"
						:container-class="'pagination'"
						:page-class="'page-item'"
						:current-page="currentPage"
					>
					</paginate>
				</b-col>
		   </b-card>
		</b-col>
	  </b-row>
	  </div>
  </template>
  <script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import auth from '@/utils/auth'
  
  export default {
	data: function() {
	  return{
		is_superadmin : '',
		selectedDate : new Date(),
		fields: [ { key: 'shippingid', label:'Shipping ID',sortable: true,sortDirection:'desc'},
		{ key: 'ofdshipmentstatus', label:'OFD Shipment Status',sortable: true,sortDirection:'desc',class:'text-center'},
		{ key: 'ofddeliveryagentmasterid', label:' OFD Deliveryagentmaster ID',sortable: true,sortDirection:'desc',class:'text-center'},
		{ key: 'nextshipmentstatus', label:'Next Shipment Status',sortable: true,sortDirection:'desc',class:'text-center'},
		{ key: 'nextdeliveryagentmasterid', label:'Next Deliveryagentmaster ID',sortable: true,sortDirection:'desc',class:'text-center'},
		{ key: 'nextridername', label:'Rider Name',sortable: true,sortDirection:'desc'},
		// { key: 'totalofdcount', label:'Total OFD Count',sortable: true,sortDirection:'desc'},
	],
        ofdstatus : [],
		totalcount : 0,
		isBusy: false,   
		hublistData:[],
		selected_serviceid : '',
		data1:'',
		selected_deliverydata  : '',
		currentPage: 1,
		perPage:20,
		noofpages: 0,
	  }
	},
	created() {
		var userdata = localStorage.getItem('userData')
		var userInfo = JSON.parse(userdata)
		this.is_superadmin = userInfo.is_superadmin
		console.log(userInfo)
		this.StatusOfdInKSA(1);
		this.gethublist();
		this.displaydata();
	},
	methods: {
		formatDate: function(date) {
			var d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear();
			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;
			return [year, month, day].join("-");

		},

		gethublist: function(){
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
        
          const obj = {
            hub_id:`${userInfo.pickuplocationmasterid}`,
          
          };
        
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
            .then(result => {
              
              if(result.body.returnmsg=='Successful'){
              this.hublistData = result.body.returnvalue;
            
              }
              
            })
            .catch(ex => {
              alert('error-----',ex);
            });
        },

		displaydata: function() {
			var userdata = localStorage.getItem('userData')
			var userInfo = JSON.parse(userdata)
			console.log(userInfo,"----------------")
			if(userInfo.sysusermasterid==25 )
			{
				let customerGetobj = {
					deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
					isactive: '1',
					usertype:'4',
					is_finance_superadmin : `${userInfo.is_finance_superadmin}`,
					hub_id:`${userInfo.pickuplocationmasterid}`,
				}
				this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
					.then((result) => {
					this.data1 = result.body;
					var data = [];
 
					result.body.forEach(function (srData) {
						data.push({
						key:srData.deliveryagentmasterid,
						label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
						});
					});
					this.data1 = data;
					// this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
					})
					.catch((ex) => {
					console.log('error', ex)
					})
			}
			else
			{
			let customerGetobj = {
				deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
				isactive: '1',
				is_finance_superadmin : `${userInfo.is_finance_superadmin}`,
				hub_id:`${userInfo.pickuplocationmasterid}`,
			}
			this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, customerGetobj)
				.then((result) => {
				this.data1 = result.body;
				var data = [];
 
					result.body.forEach(function (srData) {
						data.push({
						key:srData.deliveryagentmasterid,
						label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
						});
					});
					this.data1 = data;
				// this.data1.sort(this.GetSortOrder('deliveryagentfirstname'))
				})
				.catch((ex) => {
				console.log('error', ex)
				})
			
			}
		},

		StatusOfdInKSA : function(page){
			var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

			if(page==1){
				this.ofdstatus = [];
				this.totalcount = 0;
				this.noofpages = 0;
			}
			console.log("ooooooo",userInfo)
			this.isBusy = true;
			if (this.selected_deliverydata == "") {
				this.obj={
					hub_id:`${userInfo.pickuplocationmasterid}`,
					createddate: this.formatDate(this.selectedDate),
					serviceid : `${this.selected_serviceid}`,
					page : page ? page : 1,
					limit : this.perPage
				}
			} else {
				this.obj={
					hub_id:`${userInfo.pickuplocationmasterid}`,
					createddate: this.formatDate(this.selectedDate),
					serviceid : `${this.selected_serviceid}`,
					deliveryagentmasterid: `${this.selected_deliverydata.key}`,
				}
			}
            // let obj={
			// 	hub_id:`${userInfo.pickuplocationmasterid}`,
            //     createddate: this.formatDate(this.selectedDate),
			// 	serviceid : `${this.selected_serviceid}`,
			// 	deliveryagentmasterid: `${this.selected_deliverydata}`,
            // }

            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getNextStatusLogAfterOfdInKSA`, this.obj).then((result) => {
            console.log("result",result)
			this.isBusy = false;
			if (result.data.returnmsg == "Successful") {
				this.ofdstatus= result.data.returnvalue;
				console.log("PPPPPPPPPPPPPPPPp",this.ofdstatus)
				this.totalcount =  result.data.returnvalue[0].total_count;
				this.noofpages=parseInt(this.totalcount)/this.perPage;
          		this.noofpages=Math.ceil( this.noofpages);
			}
			else{
				this.ofdstatus= [];
				this.totalcount=0;
				this.noofpages=0;
			}
		})
		.catch((ex) => {
            console.log('error-----', ex)
        })

		},

		clear: function(){
			this.selected_deliverydata = '';
			this.selected_serviceid = '';
			this.customer = {};
			this.selectedDate = new Date();
			this.StatusOfdInKSA(1);
		},

		Downloadofd: function(){
			var userdata = localStorage.getItem("userData");
			var userInfo = JSON.parse(userdata);
			document.getElementById("overlay").style.display = "block";
			let obj = {
				sysusermasterid: `${userInfo.sysusermasterid}`,
				createddate: this.formatDate(this.selectedDate),
				serviceid : this.selected_serviceid== "" ? `${userInfo.pickuplocationmasterid}`:`${this.selected_serviceid}`,
				// deliveryagentmasterid: `${this.selected_deliverydata.key}`,
			};
			console.log("ggggg", obj);
			this.$http
			.post(`${CONSTANTS.MISREPORT_API_URL}/ofd_Basic_Report_CSV`, obj)
			.then((result) => {
				document.getElementById("overlay").style.display = "none";
			if (result.body == "success") {
				this.$fire({
				text: "Please Check Your Mail For Downlod Link",
				type: "success",
				timer: 30000,
				});
			} else {
				this.$fire({
				text: "Can not Download",
				type: "error",
				timer: 30000,
				});
			}
			});
		},

		GetSortOrder : function(prop) {
			return function(a, b) {
				if (a[prop] > b[prop]) {
					return 1;
				} else if (a[prop] < b[prop]) {
					return -1;
				}
				return 0;
			}

		},

		selectdeliveryagent(value_vehicle) {
			if(value_vehicle==null){
			this.selected_deliverydata = '';
			this.gethublist();
			this.displaydata();
			this.StatusOfdInKSA(1);
			}
			console.log("value_vehicle : ",value_vehicle);
		},
	},
  }
  </script>
  
  